<template>
  <div>
    <div class="d-flex align-center">
      <div class="text-5 gray--text mr-5">01</div>
      <div class="heading-5 font-weight-medium">
        Select Signer
      </div>
    </div>
    <p class="text-5 mt-3">
      Please select signer address to connect and sign this transaction
    </p>
    <div class="mt-2 owners-wrap">
      <div
        :class="[
          'd-flex align-center justify-center mt-2 eth-address clickable',
          { selected: signerAddress === owner.address },
        ]"
        v-for="owner in missingOwners"
        :key="owner.address"
        v-ripple
        @click="selectSigner(owner.address)"
      >
        <div class="text-4 primary--text">
          {{ owner.address }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["signerAddress"],
  computed: {
    ...mapGetters({
      gnosisWallet: "userWallets/gnosis/wallet",
    }),
    missingOwners() {
      const owners = this.gnosisWallet.metadata.owners;
      // filter out signed owners
      return owners;
    },
  },
  methods: {
    selectSigner(address) {
      this.$emit("setSignerAddress", address);
    },
  },
};
</script>

<style lang="scss" scoped>
.owners-wrap {
  max-height: 160px;
  overflow: auto;
  .eth-address {
    height: 44px;
    border-radius: 50px;
    background-color: var(--smoke);
    &.selected {
      border: 1px solid var(--orange);
      background: rgba(246, 96, 51, 0.1);
    }
  }
}
</style>
